import React from 'react';
import {withRouter} from 'react-router-dom';
import {connect} from 'react-redux';

import {CardContainer, Loading, Ribbon, Button, Dialog, Input, Validator, Notification} from 'components/common/uiKit';
import {Language} from 'components/common/app'

import {serverUrl} from 'services/network';
import {CourseApi} from 'services/network/api';
import {convertDigitsToStandard} from 'services/converts/numbers';

import NoImage from 'assets/images/NoImage.jpg';


class Course extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            loading: true,
            courseName: '',
            createBtnLoading: false,
            showAddDialog: false
        };

        this.validator = Validator(props.locale.abbreviation);

        this.loadData();
    }

    loadData() {
        CourseApi.GetAll()
            .then(res => {
                if (res && res.status == 200) {
                    let {data} = res;
                    const actives = data.filter(x => x.stateDesc.toLowerCase() == 'active');
                    const others = data.filter(x => x.stateDesc.toLowerCase() != 'active');
                    data = [];
                    data.push(...actives, ...others);
                    this.setState({data});
                }
            }).finally(x => {
            this.setState({loading: false});
        });
    }

    handleCourseState(state) {
        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Course.CourseStatus;

        switch (state.toLowerCase()) {
            case 'inactive':
                return {title: pageTranslates.InActive, type: 'danger'};
            case 'active':
                return {title: pageTranslates.Active, type: 'success'};
            case 'fullcapacity':
                return {title: pageTranslates.FullCapacity};
            case 'canceled':
                return {title: pageTranslates.Canceled, type: 'warning'};
            case 'commingsoon':
                return {title: pageTranslates.CommingSoon, type: 'info'};
            case 'draft':
                return {title: pageTranslates.Draft, type: 'danger'};
        }
    };

    _handleClick = (item) => {
        const {history} = this.props;
        const {id, stateDesc} = item;

        history.push({
            pathname: `courseDetail?courseId=${id}`,
            //search: `?lessonId=${id}`,
            //state: {...data}
        });
    };

    _handleSubmitAddClick = () => {

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Course;

        let validationResult = true;
        validationResult = this.validator.fieldValid(pageTranslates.CourseName);

        if (validationResult) {
            this.setState({createBtnLoading: true});
            const {courseName} = this.state;
            const model = {title: courseName};

            CourseApi.Create(model)
                .then(res => {
                    if (res.status == 200) {
                        this.loadData();
                        Notification('success', 'Succeed')
                        this.setState({showAddDialog: false});
                    }
                })
                .finally(x => {
                    this.setState({createBtnLoading: false});
                });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
            Notification('error', 'WrongData');
            this.setState({createBtnLoading: false});
        }

    };

    inputChange = name => event => {
        this.setState({[name]: convertDigitsToStandard(event.target.value)});
    };

    handleChangeLanguageCallback = () => {
        this.setState({loading: true}, ()=> this.loadData());
    };

    render() {
        const {data, loading, showAddDialog, courseName, createBtnLoading} = this.state;
        if (loading)
            return <Loading/>;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Course;


        return (
            <>
                <div>
                    <CardContainer>
                        <h3 className='mb-4 color-primary text-center'>
                            {pageTranslates.Title}
                        </h3>

                        <Language size='small' callback={this.handleChangeLanguageCallback}/>
                    </CardContainer>

                    <div className="text-center" style={{padding: '10px 15px'}}>
                        <div className='mb-4'>
                            <Button full type='success' shadowType='sm' onClick={() => {
                                this.setState({showAddDialog: true})
                            }}>
                                <i className='fa fa-plus font-weight-bold ml-2'/>
                                <span className='font-weight-bold font-14'>
                                    {pageTranslates.Create}
                                </span>
                            </Button>
                        </div>
                        {data.map((item, index) => {
                            const {id, image, title, price, time} = item;
                            let imageStyle = {};

                            if (image) {
                                const imageUrl = `${serverUrl}${image.split('\\').join('/')}`;
                                imageStyle = {backgroundImage: `url(${imageUrl})`};
                            } else {

                                imageStyle = {backgroundImage: `url(${NoImage}`};
                            }

                            const ribbonProps = this.handleCourseState(item.stateDesc);

                            return (
                                <a onClick={this._handleClick.bind(this, item)}>
                                    <Ribbon {...ribbonProps}>
                                        <div className="card rounded-l shadow-l"
                                             style={{height: 320, overflow: 'hidden'}}>
                                            <div className="card-bottom">
                                                <h1 className="font-24 font-700 text-center">{title}</h1>
                                                <p className="boxed-text-xl">
                                                    {pageTranslates.Price}:
                                                    {price.toLocaleString()}
                                                    {pageTranslates.Currency}
                                                    <br/>
                                                    {pageTranslates.ExpireTime}:
                                                    {time}
                                                    {pageTranslates.Days}
                                                </p>

                                            </div>
                                            <div className="card-overlay bg-gradient-fade"></div>
                                            <div className="card-bg owl-lazy" style={imageStyle}></div>
                                        </div>
                                    </Ribbon>
                                </a>
                            );
                        })}
                    </div>
                </div>
                <Dialog open={showAddDialog} title={pageTranslates.Create}>
                    <div>
                        <div>
                            <label className='mb-0 color-primary'>
                                {pageTranslates.CourseName}
                            </label>
                            <Input placeholder={pageTranslates.CourseName} value={courseName}
                                   onChange={this.inputChange('courseName')}
                            />
                            {this.validator.message(pageTranslates.CourseName, courseName, 'required|min:3')}
                        </div>
                        <div>
                            <Button full onClick={this._handleSubmitAddClick} loading={createBtnLoading}>
                                {pageTranslates.CreateDialog.Submit}
                            </Button>
                            <Button full type='secondary' onClick={() => this.setState({showAddDialog: false})}>
                                {pageTranslates.CreateDialog.Cancel}
                            </Button>
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }
}


const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Course));
